export default {
  dateFormat () {
    return 'DD/MM/YYYY';
  },

  getAppVersion (state) {
    return state.app.version;
  },
};
